import { useEffect, useState } from 'react';
import sortArrayByProperty from '@afosto/utils/array/sortArrayByProperty';
import { integrations as integrationsApi } from '@afosto/apps/api/Integrations';

export default () => {
  const [storages, setStorages] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchStorages = async () => {
      try {
        const response = await integrationsApi.listIntegrations(
          { appCode: 'ftp', isDeleted: 0 },
          {
            headers: {
              'x-page-size': 100,
            },
          },
        );
        const { data = [] } = response;
        const sortedStorages = sortArrayByProperty(data, 'name', 'asc');

        if (isMounted) {
          setStorages(sortedStorages);
        }
      } catch (err) {
        if (isMounted) {
          setStorages([]);
        }
      }
    };

    fetchStorages();

    return () => {
      isMounted = false;
    };
  }, []);

  return [storages];
};
